import React from 'react';

import { StyledPlatformIndicator } from './PlatformIndicator.styles';

import { PlatformIndicatorProps } from './PlatformIndicator.types';

import { PlatformIcon, platformName } from '../../../';

//TODO Remove Duplicate "className" prop (duplicate of "customClassnames")
const PlatformIndicator = ({
  platform,
  iconSize = 16,
  customClass,
  componentClassname = 'platform-indicator',
  customClassnames = '',
  customStyle = '',
}: PlatformIndicatorProps) => {
  return (
    <StyledPlatformIndicator
      className={`${componentClassname} ${customClassnames} ${customClass}`}
      customStyle={customStyle}
      data-qa="platform-indicator"
    >
      <PlatformIcon platform={platform} size={iconSize} />
      <div className={`${componentClassname}__name`}>
        {platformName(platform)}
      </div>
    </StyledPlatformIndicator>
  );
};
PlatformIndicator.displayName = 'PlatformIndicator';

export default PlatformIndicator;
